import styles from './index.module.css'
import { Modal } from '@appkit4/react-components/modal'
import classnames from 'classnames'

export const View = ({ wrapperClassName, width, className, children, ...props }) => {
    return (
        <Modal
            wrapperClassName={classnames(styles.modalWrapper, wrapperClassName)}
            modalStyle={{ width }}
            className={classnames(styles.default, className)}
            {...props}
        >
            {children}
        </Modal>
    )
}
